import { memo } from 'react'
import type { TimelineEntry } from './EntriesTimeline'
import { EntryRow } from './EntryRow'

export const EntryGroup = memo(function EntryGroup({
  title,
  entries,
}: {
  title: string
  entries: TimelineEntry[]
}) {
  return (
    <div>
      <h3 className="text-muted-foreground mb-2 text-xs font-medium tracking-wide uppercase">
        {title}
      </h3>
      <div className="space-y-1">
        {entries.map((entry) => (
          <EntryRow key={`${entry.type}-${entry.data.id}`} entry={entry} />
        ))}
      </div>
    </div>
  )
})
